var _mask, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 5,
    viewBox: "0 0 1440 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_637_2032",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.246094 0.253906H1439.82V4.25391H0.246094V0.253906Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1439.82 -3.74609H0.246094V12.2539H1439.82V-3.74609Z",
    fill: "url(#paint0_linear_637_2032)",
    mask: "url(#path-1-inside-1_637_2032)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_637_2032",
    x1: 0.246094,
    y1: 2.25391,
    x2: 1439.82,
    y2: 2.25391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FED506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2DB8AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDAB2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#28B2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0E0F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.0e2614538cfcadc984270d1006e28ab4.svg";
export { ForwardRef as ReactComponent };